import script from "./WorkSpaceMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./WorkSpaceMenu.vue?vue&type=script&setup=true&lang=ts"

import "./WorkSpaceMenu.vue?vue&type=style&index=0&id=63948714&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63948714"]])

export default __exports__